<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row">
                    <div class="col-12">
                        <div class="accordion accordion-flush" :id="'accordion-matrix-' + indexMatrix">
                            <div
                                v-for="(accordion, indexAccordion) in accordions"
                                :key="'accordion' + indexMatrix + indexAccordion"
                                class="accordion-item"
                            >
                                <h3
                                    class="accordion-header"
                                    :id="'accordion-header-' + indexMatrix + indexAccordion"
                                >
                                    <button
                                            class="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            :data-bs-target="accordion.tabAncre ? '#' + accordion.tabAncre : '#accordion-content-' + indexMatrix + indexAccordion"
                                            aria-expanded="false"
                                            :aria-controls="'accordion-content-' + indexMatrix + indexAccordion"
                                        >
                                            {{ accordion.accordionTitle }}
                                        </button>
                                </h3>

                                <div
                                    :id="accordion.tabAncre ? '' + accordion.tabAncre : 'accordion-content-' + indexMatrix + indexAccordion"
                                    class="accordion-collapse collapse"
                                    :aria-labelledby="'accordion-header-' + indexMatrix + indexAccordion"
                                    :data-bs-parent="'#accordion-matrix-' + indexMatrix"
                                >
                                    <div class="accordion-body">
                                        <div class="text-editor" v-html="accordion.accordionContent"></div>
                                        <a
                                            v-if="accordion.accordionLink.link !== ''"
                                            :href="accordion.accordionLink.link"
                                            :target="accordion.accordionLink.target"
                                            class="link-arrow right mb-3 mt-4 d-block"
                                        >
                                            {{accordion.accordionLink.customText}}
                                        </a>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'accordionFullWidth',
    components: {
        // AssetLoader
    },
    props: {
        accordions: {
            type: Array,
            required: true,
        },
        indexMatrix:{
            type: Number,
            required: false,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
